// src/constants/links.js
export const EXTERNAL_LINKS = {
    TERMS: process.env.REACT_APP_TERMS_OF_SERVICE_URL,
    PRIVACY: process.env.REACT_APP_PRIVACY_POLICY_URL,
};